import { initializeApp } from "firebase/app";
import { initializeAnalytics } from "firebase/analytics";
import { useEffect } from "react";
import { matchRoutes, useLocation } from "react-router-dom";
import { logEvent } from "firebase/analytics";
import { getPageTitle, PagePathes } from "constants/routes";
import { firstMatchingRoute } from "pages/Player/PlayerPageTabs";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_GOOGLE_ANALYTICS_API_KEY,
  authDomain: "patron-360.firebaseapp.com",
  projectId: "patron-360",
  storageBucket: "patron-360.appspot.com",
  messagingSenderId: "235067216541",
  appId: "1:235067216541:web:62ebcd7025f3363cd8ba74",
  measurementId: "G-F102QEQGKG",
};

const app = initializeApp(firebaseConfig);
export const analytics = initializeAnalytics(app, {
  config: {
    send_page_view: false,
  },
});

export const logPageTitleChange = (title: string) => {
  logEvent(analytics, "page_view", {
    page_title: title,
  });
  console.log(`Page Title: ${title}`);
};

export const GoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    const match = firstMatchingRoute(PagePathes, location);
    if (match) {
      document.title = getPageTitle(match);
    }
    logPageTitleChange(document.title.split("|").reverse()[0]);
  }, [location.pathname]);

  return <></>;
};
